<template>
  <div class="error-container">
    <div class="error-container-inner">
      <div class="error_box">
        <h2>ご契約がないためサービスをご利用いただけません。<br>ご不明な場合は担当者にご連絡ください。</h2>
        <div class="support">
          <p class="mail">support-skyfox@sxi.co.jp</p>
          <p class="time">サービス時間：平日 10:00～18:00</p>
        </div><!--support-->
        <el-button type="primary" class="large" @click="logout()" style="height: 50px; padding: 8px 20px;">ログインへ戻る
        </el-button>
      </div><!--login_box-->

      <div class="logo-container"><img src="../../../static/img/logo_sx.png" width="200" height="38" alt="SecondXight"></div>
      <p class="copyright">Copyright © 2019 SecondXight, Inc. All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import BaseView from '../base'

export default {
  name: 'NoContractErrorView',
  mixins: [BaseView],
  data () {
    return {}
  },
  methods: {
    logout () {
      window.location.href = '/'
    }
  }
}

</script>

<style scoped>
  .error-container {
    min-height: 100%;
  }

  .error-container-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -255px;
    margin-left: -240px;
    width: 480px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .error_box {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.4);
    margin: 0 0 40px 0;
    padding: 60px 40px;
    text-align: center;
    align-items: center;
    width: 100%;
  }

  .error_box h1,
  .error_box h2,
  .error_box h3 {
    color: #d8243e;
  }

  .error_box h1 {
    font-size: 2.8rem;
    font-weight: bold;
    margin: 0;
    line-height: 1;
  }

  .error_box h2 {
    font-size: 1rem;
    font-weight: bold;
    margin: 10px auto 20px auto;
  }

  .error_box h3 {
    font-size: 1.5rem;
    font-weight: normal;
    margin: 0 0 20px 0;
  }

  .error_box .mail:first-child {
    display: inline;
    text-align: left;
    width: auto;
    margin: 0 auto 20px auto;
    font-size: 1.25rem;
  }

  .support > .time {
    margin: 10px 0 20px 0;
    font-size: 0.88rem;
  }

  .mail {
    font-size: 1.50rem;
    font-weight: bold;
    background: url(../../../static/img/mail.png) no-repeat left center;
    background-size: 26px 18px;
    padding: 0 0 0 40px;
    line-height: 1;
    margin: 0 0 16px 0;
  }

  .logo-container {
    display: flex;
    justify-content: center;
  }

  .copyright {
    color: #fff;
    font-size: 0.63rem;
    margin: 10px auto 50px auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/no-contract-error/no-contract-error.vue